import React from "react";
import { AiOutlineCoffee } from "react-icons/ai";
import { useLocation, useNavigate } from "react-router-dom";
import DailyActivityHome from "./DailyActivityHome";
import DailyActivityHistory from "./DailyActivityHistory";

const TABS = [
  { key: "today", label: "Today" },
  { key: "history", label: "History" },
];

const SwitchDailyActivity = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const tab = queryParams.get("tab") === "history" ? "history" : "today";

  const handleTabChange = (key) => {
    queryParams.set("tab", key);
    navigate({ search: queryParams.toString() });
  };

  return (
    <div className="p-4 sm:p-8">
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="flex items-center gap-4 mb-6">
          <div
            className="flex items-center justify-center rounded-full shrink-0"
            style={{ width: 48, height: 48, background: "#ffe4d5", color: "#c2410c" }}
          >
            <AiOutlineCoffee size={24} />
          </div>
          <div>
            <div className="text-2xl text-orange-500 font-semibold leading-tight">
              Day Care Activity
            </div>
            <div className="text-gray-400 text-sm">
              Log meals, loo visits and naps, and track them over time.
            </div>
          </div>
        </div>

        {/* Tab bar */}
        <div
          className="bg-white rounded-lg mb-6"
          style={{ display: "grid", gridTemplateColumns: `repeat(${TABS.length}, 1fr)` }}
        >
          {TABS.map(({ key, label }) => (
            <div
              key={key}
              onClick={() => handleTabChange(key)}
              className={`iskool-tab-item ${tab === key ? "bg-gray-600 text-white shadow" : ""}`}
            >
              <div className="text-lg">{label}</div>
            </div>
          ))}
        </div>

        {tab === "history" ? <DailyActivityHistory /> : <DailyActivityHome />}
      </div>
    </div>
  );
};

export default SwitchDailyActivity;
